export const currencySymbol = "₹";
